/* eslint-disable */
import { useEffect, useRef } from "react";
import ActionButton from "../framework/forms/helpercomponents/buttons/ActionButton"
import CancelButton from "../framework/forms/helpercomponents/buttons/CancelButton";
import SaveButton from "../framework/forms/helpercomponents/buttons/SaveButton";
import { useTranslation } from "../locale/useTranslation";
import { utility } from "../framework/utility/utilityProvider";
import { DropDownList } from "@progress/kendo-react-dropdowns";


export const EditPageHeader = (props) => {

  const lang = useTranslation();

  let showTitle = props.showTitle ?? true;
  let saveButtonTitle = props.saveButtonTitle ?? lang.save_button_text;
  let saveAndCloseButton = props.saveAndCloseTitle ?? lang.save_and_close_text;
  let showSpots = props.showSpots ?? false;
  let showSaveAndCreateWorkOrder = props.showSaveAndCreateWorkOrder ?? false;
  let showDraft = props.showDraft ?? false;
  let showPreview = props.showPreview ?? false;
  let showSaveAndRun = props.showSaveAndRun ?? false;
  let showStatusCell = props.showStatusCell ?? false;
  let status = props.status ?? '';
  let statusCellColor = props.statusCellColor ?? '#ffffff';
  let showMediaTemplate = props.showMediaTemplate ?? false;
  let showSaveButton = props.showSaveButton ?? true;
  let isLoading = props.isLoading ?? false;
  let showCreateFrom = props.showCreateFrom ?? false;
  let showSaveAndCancelButton = props.showSaveAndCancelButton ?? false;
  let OpenMediaButton = props.OpenMediaButton ?? false;

  const handleKeyDown = (event) => {
    if (event.key == "Escape") {
      props.onCancel();
    } else if (event.keyCode == 83 && event.ctrlKey) {
      props.onSubmit();
    } else {
      // console.log(event.key);
    }
  }


  useEffect(() => {
    //subscribe event
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      // unsubscribe event
      window.removeEventListener('keydown', handleKeyDown)
    };
  }, [])

  const onSubmitAndClose = () => {
    props.onSubmit(true);
  }

  const onSubmit = () => {
    props.onSubmit();
  }

  const onCancel = () => {
    props.onCancel();
  }

  return <div className="flex-container wrap">
    <div className="row mt-1 mb-1" style={{ marginLeft: '-25px' }}>
      <div className="col">
        {showSaveAndCancelButton && <SaveButton tooltip={saveAndCloseButton} disabled={isLoading} isLoading={isLoading} title={saveAndCloseButton} btnColor={props.saveBtnColor} onClick={onSubmitAndClose}></SaveButton>}
        {showSaveButton && <SaveButton tooltip={saveButtonTitle} disabled={isLoading} isLoading={isLoading} title={saveButtonTitle} btnColor={props.saveBtnColor} onClick={onSubmit}></SaveButton>}
        {showDraft && <ActionButton title={lang.save_draft_button_tooltip} name={lang.save_draft_button_title} btnColor={'info'} onClick={props.onSaveDraft} />}
        {showSpots && <ActionButton title={lang.show_spots_button_tooltip} name={lang.show_spots_button_text} btnColor={'warning'} onClick={props.onShowSpots} />}
        {showSaveAndCreateWorkOrder && <ActionButton title={lang.save_and_create_work_order_button_tooltip} name={lang.save_and_create_work_order_button_text} btnColor={'info'} onClick={props.onSaveAndCreateWorkOrder} />}
        {showPreview && <ActionButton title={lang.preview_button_text} name={lang.preview_button_tooltip} btnColor={'info'} onClick={props.onPreview} />}
        {showSaveAndRun && <ActionButton title={lang.save_and_run_button_text} name={lang.save_and_run_button_text} btnColor={'info'} onClick={props.onSaveAndRun} />}
        <CancelButton onClick={onCancel}></CancelButton>
        {OpenMediaButton && <ActionButton title={lang.show_media_label} name={lang.show_media_label} btnColor={'info'} onClick={props.onShowMedia} />}

        {showMediaTemplate && <ActionButton title={lang.save_and_create_media_template_button_tooltip} name={lang.save_as_media_template_button_text} btnColor={'info'} onClick={props.onSaveAndCreateMediaTemplate} />}
        {showMediaTemplate && <ActionButton title={lang.select_media_template_button_tooltip} name="..." btnColor={'info'} onClick={props.onSelectMediaTemplate} />}
        {showCreateFrom && <ActionButton title={lang.select_create_from_button_tooltip} name="Create From" btnColor={'info'} onClick={props.onCreateFrom} />}
        {props.defaultLanguage && props.defaultLanguage.length > 0 &&
          <button style={{ marginLeft: "8px", backgroundColor: "#f5f5f5", color: "#808080", border: "1px solid #dcdcdc", borderRadius: "4px", padding: "5px 22px", fontSize: "15px", cursor: "pointer", boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.1)" }}>
            {props.defaultLanguage}
          </button>}
      </div>
      {props.languages?.length > 0 && props.selectedLanguage && <DropDownList
        data={props.languages}
        style={{ backgroundColor: 'white', width: '200px', height: '34px' }}
        name="Language"
        textField="Description"
        dataItemKey="_id"
        value={props.selectedLanguage}
        onChange={(e) => props.setSelectedLanguage(e.target.value, true)}
      />}
    </div>
    <div className="mr-2" style={{ marginTop: '-10px' }}>

      {showTitle && <h1 className="page-edit-title txt-color-bludeDark">
        <i
          className="fa fa-pencil marlr"
          style={{ fontSize: "15px", color: "GrayText" }}
        ></i>
        <span>{utility.subString(props?.title ?? "", 30)}</span>
      </h1>}
      {showStatusCell && status.length > 0 &&
        <h1 style={{ margin: '10px 0px 0px 0px', padding: '10px 0px 0px 0px' }}>
          <span title={status}
            style={{
              fontSize: '13px',
              fontWeight: 'normal',
              color: 'white',
              letterSpacing: "1px",
              backgroundColor: statusCellColor,
              padding: '4px 10px',
              border: `1px solid ${statusCellColor}`,
              borderRadius: '5px',
            }}>{status}</span>
        </h1>}
    </div>

  </div>
}